// extracted by mini-css-extract-plugin
export default {"edited-value-bullet":"components-settings-currency-conversion-tables-cells-td-number-module__edited-value-bullet"};